export default {
    current_contact: (state) => {
        return state.current_contact
    },

    list: (state) => {
        return state.list
    }
}